module.exports = __webpack_public_path__ + "media/taxons/clock-fast-blue-33c76340.svg";